import { AnyAction } from 'redux';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import productUidChangedOperation from 'src/store/design/operation/productUidChangedOperation';
import setProductBundleSelectedProductsOperation from 'src/store/productBundle/operation/setProductBundleSelectedProductsOperation';
import sendSetDesignDataPostMessageOperation from 'src/store/app/operation/sendSetDesignDataPostMessageOperation';
import getStructure from 'src/store/design/selector/getStructure';
import updateProductUidInDesignStructureOperation from 'src/store/design/operation/updateProductUidInDesignStructureOperation';
import { setIncludeDpiEnhancementAction, setIncludeCanvasHangerKitAction, setDesignQuantityAction } from 'src/store/design/slice';

interface UpsellProduct {
  aovQuantity?: number | null;
  aovDPIUpsell?: boolean | null;
  aovHangerKitUpsell?: boolean | null;
}

const upgradeProductByUpsellOperation = (
  productUid: string,
  internalUid: string,
  productId: number,
  bundledProducts: any[],
  product?: UpsellProduct,
) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  // designFormatChangedOperation
  await dispatch(productUidChangedOperation({
    productUid,
    internalUid,
    productId,
  }));

  // rewrite bundled products
  dispatch(setProductBundleSelectedProductsOperation(bundledProducts));

  // update AOV fields from product if provided
  if (product) {
    if (product.aovDPIUpsell !== undefined && product.aovDPIUpsell !== null) {
      dispatch(setIncludeDpiEnhancementAction(product.aovDPIUpsell));
    }
    if (product.aovHangerKitUpsell !== undefined && product.aovHangerKitUpsell !== null) {
      dispatch(setIncludeCanvasHangerKitAction(product.aovHangerKitUpsell));
    }
    if (product.aovQuantity !== undefined && product.aovQuantity !== null) {
      dispatch(setDesignQuantityAction(product.aovQuantity));
    }
  }

  // update productUid in design structure
  dispatch(updateProductUidInDesignStructureOperation(productUid));

  // push updated design to the editor
  const designStructure = getStructure(getState());
  dispatch(sendSetDesignDataPostMessageOperation(designStructure));
};

export default upgradeProductByUpsellOperation;
